import { createReducer, on } from '@ngrx/store';
import * as CompanyActions from './company-info.actions';
import { CompanyInfoState } from './company-info.models';

export const initialState: CompanyInfoState = {
  company: null,
  loading: false,
  error: null,
};

export const companyInfoReducer = createReducer(
  initialState,
  on(CompanyActions.loadCompany, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CompanyActions.loadCompanySuccess, (state, { company }) => {
    if (company) {
      return {
        ...state,
        company: { [company.CompanyGuid]: company },
        loading: false,
        error: null,
      };
    } else {
      return {
        ...state,
        loading: false,
        error: 'Company data is empty or undefined',
      };
    }
  }),
  on(CompanyActions.loadCompanyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(CompanyActions.resetCompany, () => initialState),
);
